import { Component, Input } from '@angular/core';
import { faCircleNotch, IconDefinition } from "@fortawesome/free-solid-svg-icons";

export enum LoaderType {
    large = 'large',
    small = 'small',
    medium = 'medium',
    inline = 'inline'
}

@Component({
    selector: 'loader',
    template: `
        <div class="content-loader" [ngClass]="type">
            <div class="loader-ctn">
                <fa-icon *ngIf="icon" [icon]="icon" [spin]="true" class="loader"></fa-icon>
                <div class="loader-message">{{ message }}</div>
            </div>
        </div>
    `,
    styles: [`
        .large .loader-ctn {
            display: flex;
            align-items: center;
            flex-direction: column;
            margin: 15px;
            font-size: 1rem;
        }

        .loader {
            color: #ced6e0;
            animation-duration: .5s;
            animation: fa-spin .5s infinite linear !important;
        }

        .large .loader {
            margin-bottom: 15px;
            font-size: 3rem;
        }

        .small .loader {
            font-size: 1rem;
        }

        .medium .loader {
            font-size: 1.5rem;
        }

        .large .content-loader {
            display: flex;
            align-items: center;
            justify-content: center;
        }

        .inline .content-loader,
        .inline .loader-ctn{
            display: inline-block;
        }

        .inline .loader-message{
            display: inline;
            vertical-align: middle;
        }

        .inline i.loader{
            margin-right: 0.25em;
            vertical-align: middle;
        }
        
        .inline.inline-large .loader {
            font-size: 1.5rem;
            vertical-align: middle;
        }

        .inline.inline-large .loader-message {
            font-size: 1rem;
        }
    `]
})
export class LoaderComponent {
    @Input()
    public message: string | null = null;

    @Input()
    public type: LoaderType = LoaderType.large;

    public icon: IconDefinition = faCircleNotch;
}
